import React, { useEffect, useState } from "react";
import CustomerHeader from "../Common/CustomerHeader";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import showNotification from "../../services/redux/NotifcationService";
import { DetailsApi, step5Call } from "../../services/redux/ApiActions";
import Stepper from "../Common/Stepper";
import LogoDiv from "../Common/LogoDiv";
import { setCustomerAuthenticate } from "../../services/redux/CustomerAuthentication";
import { setDetailsData } from "../../services/redux/DetailsReducer";
import { setCustomerData } from "../../services/redux/CustomerDataReducer";
import { setSuccessPage } from "../../services/redux/SuccessReducer";
import PDF from "../../Terms-and-Conditions-V2P.pdf";
import { setCustomerBankDetails } from "../../services/redux/CustomerBankDataReducer";
import logo from "../../img/BBPS_Horizontal.png";

export default function StepSeven() {
  const [isChecked, setIsChecked] = useState(false);
  const details = useSelector((state) => state.details.details);
  const customerData = useSelector((state) => state.customerData.customerData);
  const gstinResponse = JSON.parse(details?.result?.gstinResponse);
  const panResponse = JSON.parse(details?.result?.panResponse);
  const containsProprietor = details?.result?.businessType
    .toLowerCase()
    .includes("proprietor");
  const containsPerson = details?.result?.businessType
    .toLowerCase()
    .includes("person");
  const containsHindu = details?.result?.businessType
    .toLowerCase()
    .includes("hindu");
  const containsPartnership = details?.result?.businessType
    .toLowerCase()
    .includes("partnership");
  const doesntContainsLiability = !details?.result?.businessType
    .toLowerCase()
    .includes("liability");
  const containsLiability = details?.result?.businessType
    .toLowerCase()
    .includes("liability");
  const containsPrivate = details?.result?.businessType
    .toLowerCase()
    .includes("private");
  const containsPublic = details?.result?.businessType
    .toLowerCase()
    .includes("public");
  const doesntContainsPrivate = !details?.result?.businessType
    .toLowerCase()
    .includes("private");
  const doesntContainsPublic = !details?.result?.businessType
    .toLowerCase()
    .includes("public");
  const containsSociety = details?.result?.businessType
    .toLowerCase()
    .includes("society");

  const [isDirectorList, setIsDirectorList] = useState(
    containsPrivate || containsPublic || containsLiability,
  );
  const [isPartnerList, setIsPartnerList] = useState(
    (containsPartnership && doesntContainsLiability) || containsSociety,
  );
  const [isProprietorList, sePIsproprietorList] = useState(
    containsProprietor || containsPerson || containsHindu,
  );

  const [termsAndConditions, setTermsAndConditions] = useState(false);
  const [notificationsCheck, setNotificationsCheck] = useState(false);
  const [showLogo, setShowLogo] = useState(false);

  const handleTermsAndConditions = () => {
    setTermsAndConditions(!termsAndConditions);
  };

  const handleNotificationCheck = () => {
    setNotificationsCheck(!notificationsCheck);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleSubmit = async () => {
    const payload = {
      customerId: customerData?.custId,
      submittedIp: "",
      submittedUserAgent: "",
      IsAgree: isChecked,
    };
    // console.log(isChecked)
    try {
      if (isChecked === false) {
        showNotification(
          "Please check the checkbox if you want to proceed",
          "warning",
        );
      } else if (termsAndConditions === false) {
        showNotification("Please Accept Terms And Conditions", "warning");
      } else if (notificationsCheck === false) {
        showNotification(
          "Please allow SMS and Whatsapp notifications",
          "warning",
        );
      } else {
        // console.log('checkbox is clicked');
        const data = await dispatch(
          step5Call(payload, customerData?.token_chr),
        );
        if (data) {
          showNotification("Profile Submitted Successfully", "success");
          dispatch(setSuccessPage(true));
          dispatch(setCustomerAuthenticate(false));
          // navigate('/Customer/Success')
        }
      }
    } catch (error) {
      showNotification(error, "error");
    }
    // Here you can perform further actions with the payload, such as sending it to a server
  };

  const handleRoute = () => {
    if (containsProprietor || containsPerson || containsHindu) {
      // Do something if any of the conditions are true
      navigate("/Customer/Step3Properitor");
    } else if (containsPartnership && doesntContainsLiability) {
      navigate("/Customer/Step3Partner");
    } else {
      navigate("/Customer/Step3Cin");
    }
  };
  const getDetails = async () => {
    // console.log(userAgent)
    const Payload = {
      id: customerData?.custId,
    };
    // console.log(Payload)
    const data = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer"),
    );
    dispatch(setDetailsData(data));
    if (data?.result?.programId === 32 || data?.result?.programId === 33) {
      setShowLogo(true);
    } else {
      setShowLogo(false);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  function maskNumber(number) {
    // Convert number to string if it's not already
    const str = number?.toString();
    // Ensure the number has at least 4 digits
    if (str.length <= 4) {
      return str; // Return as is if 4 or fewer digits
    }
    // Mask all but the last 4 digits
    const maskedPart = "*".repeat(str?.length - 4);
    const lastFourDigits = str.slice(-4);
    return maskedPart + "-" + lastFourDigits;
  }

  return (
    <>
      <div className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2 shadow-xl p-6 mt-4 mb-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2">
                        <div className="flex justify-center">
                          <h1 className="text-xl font-semibold letter-spacing mr-2">
                            Company Details
                          </h1>
                          <svg
                            onClick={() => navigate("/")}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="#23527C"
                            className="w-6 h-6 cursor-pointer"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width="100px" height="100px" />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-2 border-none border-collapse rounded-md">
                    <table className=" w-full">
                      <tbody>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Trade Name :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {gstinResponse.TradeName}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Legal Name :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {gstinResponse.LegalName}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">GSTIN : </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {details?.result.gstin}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">Address : </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {gstinResponse.FullAddress}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Business Type :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {gstinResponse.BusinessType}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              GSTIN Status :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {gstinResponse.GSTINStatus}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">PAN : </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {details?.result.pan}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              PAN Holder:{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {panResponse.lastName}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              PAN Status :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {details?.result.panStatus}
                          </td>
                        </tr>
                        {/* <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">Is Tax Payment Type SEZ Unit : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">{details?.result.sez === true ? 'Yes' : 'No'}</td>
                                                </tr> */}
                      </tbody>
                    </table>
                  </div>
                  <div className="py-2 mt-6">
                    <div className="flex justify-center">
                      <h1 className="text-xl font-semibold letter-spacing mr-2">
                        ACCOUNT DETAILS
                      </h1>
                      <svg
                        onClick={() => navigate("/Customer/Step5")}
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="#23527C"
                        className="w-6 h-6 cursor-pointer"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className=" border-none border-collapse rounded-md">
                    <table className=" w-full">
                      <tbody>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Bank account name :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {details?.result?.customerBankDetails
                              ?.accountName || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Bank account number :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {" "}
                            {details?.result?.customerBankDetails?.accountNumber
                              ? maskNumber(
                                details?.result?.customerBankDetails
                                  ?.accountNumber,
                              )
                              : "" || "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">
                              Bank name :{" "}
                            </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {details?.result?.customerBankDetails?.bankName ||
                              "N/A"}
                          </td>
                        </tr>
                        <tr className="border-b-2">
                          <td className="w-full sm:w-1/4 p-2" align="left">
                            <label className="font-semibold">IFSC : </label>
                          </td>
                          <td
                            className="p-2 text-sm text-gray-800"
                            align="left"
                          >
                            {details?.result?.customerBankDetails?.ifsc ||
                              "N/A"}
                          </td>
                        </tr>
                        {/* <tr className="border-b-2">
                                                    <td className="w-full sm:w-1/4 p-2" align="left">
                                                        <label className="font-semibold">Is Verified : </label>
                                                    </td>
                                                    <td className="p-2 text-sm text-gray-800" align="left">{details?.result?.customerBankDetails?.isVerified ? 'Verified' : 'Not Verified'}</td>
                                                </tr>    */}
                      </tbody>
                    </table>
                  </div>
                  {isDirectorList && (
                    <>
                      <div className="mt-8 mb-4 flex justify-center">
                        <h1 className="text-xl font-semibold letter-spacing mr-2">
                          LIST OF DIRECTORS
                        </h1>
                        <svg
                          onClick={handleRoute}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="#23527C"
                          className="w-6 h-6 cursor-pointer"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                          />
                        </svg>
                      </div>
                      <div className="overflow-x-auto border rounded-md shadow-sm">
                        <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-100">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Sr.No
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Designation
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                DIN
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {details?.result.partners.map((partner, index) => (
                              <tr key={index} className="border-t">
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {index + 1}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.partnerName}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.designation}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.partnerPAN}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}

                  {isPartnerList && (
                    <>
                      <div className="mt-8 mb-4 flex justify-center">
                        <h1 className="text-xl font-semibold letter-spacing mr-2">
                          LIST OF {containsSociety ? "DIRECTORS" : "PARTNERS"}
                        </h1>
                        <svg
                          onClick={handleRoute}
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="#23527C"
                          className="w-6 h-6 cursor-pointer"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                          />
                        </svg>
                      </div>
                      <div className="overflow-x-auto border rounded-md shadow-sm">
                        <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-100">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Sr.No
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Name
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                PAN
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {details?.result.partners.map((partner, index) => (
                              <tr key={index} className="border-t">
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {index + 1}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.partnerName}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.partnerPAN}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}

                  {isProprietorList && (
                    <>
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          {containsHindu ? "DIRECTOR" : "PROPRIETOR"} DETAILS
                        </h1>
                      </div>
                      <div className="py-2 text-center">
                        <h1 className="text-sm text-gray-600">
                          Please check details of your organisation
                        </h1>
                      </div>
                      <div className="overflow-x-auto border rounded-md shadow-sm mt-3">
                        <table className="min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-100">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Sr.No
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                Name
                              </th>

                              <th
                                scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                              >
                                PAN
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {details?.result.partners.map((partner, index) => (
                              <tr key={index} className="border-t">
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {index + 1}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.partnerName}
                                </td>
                                <td className="px-3 text-sm py-4 w-100 border-r">
                                  {partner.partnerPAN}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                  <div className="mt-8 mb-4 flex justify-center">
                    <h1 className="text-xl font-semibold letter-spacing mr-2">
                      LIST OF USERS
                    </h1>
                    <svg
                      onClick={() => navigate("/Customer/Step4")}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="#23527C"
                      className="w-6 h-6 cursor-pointer"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                      />
                    </svg>
                  </div>
                  <div className="overflow-x-auto border rounded-md shadow-sm">
                    <table className=" min-w-full md:max-w-5xl lg:max-w-7xl xl:max-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-100">
                        <tr>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Sr.No
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Name
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Email
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Phone
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Role
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Pan
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Pan Holder
                          </th>
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Name at Bank
                          </th>
                          {/* <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2"
                          >
                            Aadhar Status
                          </th> */}
                          {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                        Mobile Number
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider border-r-2">
                                                        Gender
                                                    </th> */}
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {details?.result.customerUsers.map((partner, index) => (
                          <tr key={index} className="border-t">
                            <td className="px-3 text-sm py-4 border-r">
                              {index + 1}
                            </td>
                            <td className="px-3 text-sm py-4 border-r">
                              {partner.firstName} {partner.lastName}
                            </td>
                            <td className=" px-3 text-sm py-4 border-r">
                              {partner.email}
                            </td>
                            <td className="px-3 text-sm py-4 border-r">
                              <span className="flex justify-center">
                                {partner.phone}
                                {partner.isPhoneMatch === true ? (
                                  <>
                                    <button title={partner.nameOnPhone}>
                                      <svg
                                        style={{
                                          marginTop: "-2px",
                                          marginLeft: "2px",
                                        }}
                                        color="green"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-6 h-6"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                      </svg>
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button title={partner.nameOnPhone}>
                                      <svg
                                        style={{
                                          marginTop: "-2px",
                                          marginLeft: "2px",
                                        }}
                                        color="red"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        className="w-4 h-4"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </>
                                )}
                              </span>
                            </td>
                            <td className="px-3 text-sm py-4  border-r">
                              {partner.permissions === "others" ? (
                                <>
                                  {partner.selectedRoles ? (
                                    <>
                                      <span>
                                        {typeof partner.selectedRoles ===
                                          "string"
                                          ? partner.selectedRoles.includes("[")
                                            ? JSON.parse(
                                              partner.selectedRoles,
                                            ).join(" & ")
                                            : partner.selectedRoles
                                              .split(",")
                                              .map((role) => role.trim())
                                              .join(" & ")
                                          : null}
                                      </span>
                                    </>
                                  ) : null}
                                </>
                              ) : (
                                <span>
                                  {partner.permissions.replace("_", " & ")}
                                </span>
                              )}
                            </td>
                            <td className="px-3 text-sm py-4  border-r">
                              <span className="flex justify-center">
                                {partner.pan || ""}
                                {partner.isPanMatch === true ? (
                                  <>
                                    <button title={partner.nameOnPan}>
                                      <svg
                                        style={{
                                          marginTop: "-2px",
                                          marginLeft: "2px",
                                        }}
                                        color="green"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-6 h-6"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                      </svg>
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <button title={partner.nameOnPan}>
                                      <svg
                                        style={{
                                          marginTop: "-2px",
                                          marginLeft: "2px",
                                        }}
                                        color="red"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 16 16"
                                        fill="currentColor"
                                        className="w-4 h-4"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM8 4a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 8 4Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </button>
                                  </>
                                )}
                              </span>
                            </td>
                            <td className=" px-3 text-sm py-4 border-r">
                              {partner.nameOnPan}
                            </td>
                            <td className=" px-3 text-sm py-4 border-r">
                              {partner.nameOnPhone}
                            </td>
                            {/* <td className=" px-3 text-sm py-4 border-r">
                              {partner.aadhaar === null
                                ? "Not Provided"
                                : partner.aadhaarStatus}
                            </td> */}
                            {/* <td className=" px-3 text-sm py-4 border-r">
                                                            {partner.aadhaarPhoneNumber}
                                                        </td>
                                                        <td className=" px-3 text-sm py-4 border-r">
                                                            {partner.gender}
                                                        </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-7">
                    <div className="grid mt-6 grid-cols-12 gap-4">
                      <div className="col-span-12 md:col-span-1 lg:col-span-1">
                        <input
                          type="checkbox"
                          id="checkboxOption2"
                          name="gstin"
                          className="form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-11 lg:col-span-11">
                        <label
                          htmlFor="checkboxOption2"
                          className="text-gray-800 text-sm font-semibold"
                        >
                          I confirm that, all information provided by me are
                          correct and can be used for the purpose of onboarding
                          on Vendor To Pay platform.
                        </label>
                      </div>
                    </div>
                    <div className="grid mt-6 grid-cols-12 gap-4">
                      <div className="col-span-12 md:col-span-1 lg:col-span-1">
                        <input
                          type="checkbox"
                          id="checkboxOption2"
                          name="gstin"
                          className="mt-1 form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400"
                          checked={termsAndConditions}
                          onChange={handleTermsAndConditions}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-11 lg:col-span-11">
                        <label
                          htmlFor="checkboxOption2"
                          className="text-gray-800 text-sm font-semibold"
                        >
                          I hereby accept the{" "}
                          <a
                            target="_blank"
                            href={PDF}
                            className="text-blue-700 hover:cursor-pointer"
                          >
                            Terms & Conditions
                          </a>{" "}
                          and{" "}
                          <a
                            target="_blank"
                            href="https://vayana.com/privacy-policy/#:~:text=Vayana%20Network%20will%20not%20sell,the%20processing%20of%20the%20transaction"
                            className="text-blue-700 hover:cursor-pointer"
                          >
                            Privacy Policy
                          </a>{" "}
                          of using the Vendor To Pay platform.
                        </label>
                      </div>
                      <div className="col-span-12 md:col-span-1 lg:col-span-1">
                        <input
                          type="checkbox"
                          id="checkboxOption2"
                          name="gstin"
                          className="mt-1 form-checkbox h-5 w-5 text-indigo-600 border-2 border-gray-400"
                          checked={notificationsCheck}
                          onChange={handleNotificationCheck}
                        />
                      </div>
                      <div className="col-span-12 md:col-span-11 lg:col-span-11">
                        <label
                          htmlFor="checkboxOption2"
                          className="text-gray-800 text-sm font-semibold"
                        >
                          {/* I allow Vendor To Pay to send SMS and Whatsapp notifications. */}
                          I allow “Vay Network Services Pvt Ltd” to send SMS and
                          Whatsapp notifications.
                        </label>
                      </div>
                    </div>

                    <div className="text-center mt-4">
                      <button
                        onClick={handleSubmit}
                        className="vtpRm-action-button"
                      >
                        Proceed
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-1 lg:col-span-1"></div>
            </div>
          </div>
        </LogoDiv>
      </div>
    </>
  );
}
